import axios from "axios";
import { getCookie } from "../getcookie.js";
import { data } from "react-router-dom";
import Dashboard from "./Default.jsx";
const apiUrl = process.env.REACT_APP_API_URL;
const adminApiUrl = process.env.REACT_APP_ADMIN_API_URL;

const header = {
  'Content-Type': 'application/json; charset=UTF-8',
  "Accept": "application/json",
  "Access-Control-Allow-Origin": "*", // Required for CORS support to work
  "Authorization": getCookie("mawalog")
}


export const getFAQListApi = async () => {
  try {
    const response = await axios.get(
      adminApiUrl + `help?application=Dock`,
      {
        headers: header,
      }
    );
    return response.data;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};


export const reportAnIssueApi = async (data) => {
  try {
    const response = await axios.post(
      adminApiUrl + `report_issue`, data, { headers: header }).then((response) => {
        return response;
      }).catch((error) => {
        console.log('error...', error.response)
        return error.response;
      });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};


export const getReportIssueTypeApi = async () => {
  try {
    const response = await axios.get(
      adminApiUrl + `get_issue_type`,
      {
        headers: header,
      }
    );
    return response.data;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const getProfileDetailsApi = async () => {
  try {
    const response = await axios.get(adminApiUrl + `basicprofile`, {
      params: {},
      headers: {
        'Content-Type': 'application/json; charset=UTF-8',
        "Accept": "application/json",

        "Access-Control-Allow-Origin": "*", // Required for CORS support to work
        "Authorization": getCookie("mawalog")
      }
    }).then(async (response) => {
      return response;
    });
    return response;
  } catch (err) {
    console.error("Error fetching options:", err);
    return err.response;
  } finally {

  }
};

export const getOrgLogoApi = async () => {
  try {
    const response = await axios.get(
      adminApiUrl + `get_org_image`, { headers: header });
    return response.data;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const getAvailableDocksApi = async () => {
  try {
    const response = await axios.get(
      apiUrl + `dock/dockmaster`,
      {
        headers: header,
      }
    );
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};




export const getLocationFreeDocksApi = async () => {
  try {
    const response = await axios.get(
      apiUrl + `dashboard/freedocks?search=`,
      {
        headers: header,
      }
    );
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const getLiveMonitorApi = async () => {
  try {
    const response = await axios.get(
      apiUrl + `dashboard/livemonitor`,
      {
        headers: header,
      }
    );
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const getTimingListApi = async () => {
  try {
    const response = await axios.get(
      apiUrl + `dashboard/timings`,
      {
        headers: header,
      }
    );
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};
export const locationBasedDockOutDockInApi = async (month) => {
  try {
    const response = await axios.post(
      apiUrl + `dashboard/location_in_out?period=${month}&search=`, {}, { headers: header });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const sendOTPApi = async (data) => {
  try {
    const response = await axios.post(
      apiUrl + `sent_otp`, data, { headers: header });
    return response.data;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const verifyOTPApi = async (data) => {
  try {
    const response = await axios.post(
      apiUrl + `verify_otp`, data, { headers: header });
    return response.data;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};


//  Dashboard count api
export const getCountApi = async () => {
  try {
    const response = await axios.get(
      apiUrl + `signagedashboard/count`,
      {
        headers: header,
      }
    );
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

// External Overview API
export const getExternalOverviewApi = async () => {
  try {
    const response = await axios.get(
      apiUrl + `signagedashboard/external_overview`,
      {
        headers: header,
      }
    );
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};
// Status Overview API
export const getStatusOverviewApi = async () => {
  try {
    const response = await axios.get(
      apiUrl + `signagedashboard/device_status_overview`,
      {
        headers: header,
      }
    );
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};